/* unplugin-vue-components disabled */import { ElTag as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import { ElForm as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElInput as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElFormItem as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElSelect as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElRadioGroup as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadioButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/radio-button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "account-search"
};
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiUsdkQueryAccount } from '@/api/usdk';
import { useAppStore } from '@/store/modules/app';
import { apiInternalResetIdCard, apiInternalResetPwd, apiInternalResetSmsCount, apiInternalUnbindEmail } from '@/api/customerInternal';
import { apiGlobalUnbindUser } from '@/api/global';
import ResetPassword from './resetPassword.vue';
import { ACCOUNT_TYPE } from './config';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const useApp = useAppStore();
    const gameInfo = computed(() => useApp.gameInfo);
    const tabType = ref('internal');
    const resetPasswordRef = ref();
    const filter = ref({
      searchType: undefined,
      value: '',
      userType: ''
    });
    const searchOptions = {
      global: [{
        key: 1,
        label: 'CUID(玩家侧为UID)'
      }, {
        key: 2,
        label: '三方账号ID'
      }, {
        key: 3,
        label: '游客账号'
      }, {
        key: 4,
        label: '设备号'
      }, {
        key: 5,
        label: 'Email'
      }],
      internal: [{
        key: 1,
        label: '手机号'
      }, {
        key: 2,
        label: '登录名'
      }, {
        key: 3,
        label: '通行证'
      }, {
        key: 4,
        label: '游戏子账号'
      }, {
        key: 5,
        label: '设备号'
      }]
    };
    const globalColumns = [{
      label: '账号类型',
      prop: 'accountType'
    }, {
      label: '用户UID',
      prop: 'uid'
    }, {
      label: '角色账号ID',
      prop: 'roleId'
    }, {
      label: '邮箱',
      prop: 'email'
    }, {
      label: '昵称',
      prop: 'nickname'
    }, {
      label: '三方账号ID',
      prop: 'otherAccount'
    }, {
      label: '绑定时间',
      prop: 'bindTime'
    }, {
      label: '设备号',
      prop: 'device'
    }, {
      label: '账号状态',
      prop: 'status',
      slot: 'status'
    }, {
      label: '操作',
      action: true
    }];
    const internalColumns = [{
      label: '通行证ID',
      prop: 'passCode'
    }, {
      label: '登录名',
      prop: 'loginName'
    }, {
      label: '手机号',
      prop: 'mobile'
    }, {
      label: '账号类型',
      prop: 'type'
    }, {
      label: '三方账号昵称',
      prop: 'thirdNick'
    }, {
      label: '游戏子账号',
      prop: 'subId'
    }, {
      label: '实名状态',
      prop: 'isReal',
      slot: 'isReal'
    }, {
      label: '设备号',
      prop: 'device'
    }, {
      label: '账号状态',
      prop: 'status',
      slot: 'status'
    }, {
      label: '操作',
      action: true
    }];
    const internalConfig = {
      unlockEmail: {
        api: apiInternalUnbindEmail,
        tip: '是否确认解绑此邮箱？',
        params: {
          loginName: 'loginName',
          email: 'email'
        }
      },
      reset: {
        api: apiInternalResetPwd,
        tip: '是否确认重置密码？',
        params: {
          loginName: 'loginName'
        }
      },
      realName: {
        api: apiInternalResetIdCard,
        tip: '是否确认重置实名？',
        params: {
          loginName: 'loginName'
        }
      },
      msg: {
        api: apiInternalResetSmsCount,
        tip: '是否确认重置短信次数？',
        params: {
          tel: 'mobile'
        }
      }
    };
    const columns = computed(() => {
      return tabType.value === 'internal' ? internalColumns : globalColumns;
    });
    const getTableData = () => {
      tableLoading.value = true;
      apiUsdkQueryAccount({
        gid: gameInfo.value.Id,
        area: tabType.value === 'internal' ? 0 : 1,
        condition: filter.value.searchType,
        content: filter.value.value,
        test: '122222',
        userType: filter.value.userType
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const {
      tableData,
      tableLoading
    } = UseTable(getTableData);
    const handleGlobalClick = (type, data) => {
      if (type === 'unlock') {
        ElMessageBox.confirm('是否确认解绑此账号？', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiGlobalUnbindUser({
            uid: data.uid,
            recordId: data.recordId,
            userType: data.userType,
            gid: gameInfo.value.Id,
            hgGid: data.gid
          }).then(res => {
            if (res.code === 0) {
              getTableData();
            }
          });
        }).catch(() => {
          console.log('cancel');
        });
      } else if (type === 'reset') {
        console.log('重置密码');
        resetPasswordRef.value.show({
          data: {
            uid: data.uid,
            suid: data.roleId,
            type: data.uid ? 1 : 2,
            hgGid: data.gid,
            pwd: ''
          },
          gid: gameInfo.value.Id
        });
      }
    };
    const handleInternalClick = (type, data) => {
      const {
        api,
        params,
        tip
      } = internalConfig[type];
      const _params = {
        gid: gameInfo.value.Id
      };
      for (let key in params) {
        _params[key] = data[params[key]];
      }
      ElMessageBox.confirm(tip, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api(_params).then(res => {
          if (res.code === 0) {
            getTableData();
          }
        });
      });
    };
    watch(() => tabType.value, () => {
      filter.value = {
        searchType: '',
        value: '',
        userType: ''
      };
      tableData.value = [];
    });
    return (_ctx, _cache) => {
      const _component_el_radio_button = __unplugin_components_0;
      const _component_el_radio_group = __unplugin_components_1;
      const _component_el_option = __unplugin_components_2;
      const _component_el_select = __unplugin_components_3;
      const _component_el_form_item = __unplugin_components_4;
      const _component_el_input = __unplugin_components_5;
      const _component_el_button = __unplugin_components_6;
      const _component_el_form = __unplugin_components_7;
      const _component_el_tag = __unplugin_components_8;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_radio_group, {
        modelValue: _unref(tabType),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(tabType) ? tabType.value = $event : null)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_button, {
          label: "internal"
        }, {
          default: _withCtx(() => [_createTextVNode("国内")]),
          _: 1
        }), _createVNode(_component_el_radio_button, {
          label: "global"
        }, {
          default: _withCtx(() => [_createTextVNode("全球")]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_form, {
        class: "marginT20",
        inline: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "查询类型"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(filter).searchType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(filter).searchType = $event),
            placeholder: "请选择查询项"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchOptions[_unref(tabType)], item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.key,
                label: item.label,
                value: item.key
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(filter).value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(filter).value = $event),
            class: "width300px",
            placeholder: "请输入查询关键字"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _unref(tabType) === 'global' && _unref(filter).searchType === 2 ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(filter).userType,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(filter).userType = $event),
            placeholder: "请选择",
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ACCOUNT_TYPE), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.userType,
                label: item.label,
                value: item.userType
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            disabled: !_unref(filter).searchType || !_unref(filter).value,
            type: "primary",
            onClick: getTableData
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(UTable, {
        data: _unref(tableData),
        loading: _unref(tableLoading),
        options: _unref(columns),
        pagination: ""
      }, {
        isReal: _withCtx(({
          scope
        }) => [_createVNode(_component_el_tag, {
          type: scope.row.isReal ? 'success' : ''
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.isReal ? '已实名' : '未实名'), 1)]),
          _: 2
        }, 1032, ["type"])]),
        status: _withCtx(({
          scope
        }) => [_createVNode(_component_el_tag, {
          type: scope.row.status === 1 ? 'warning' : scope.row.status === 2 ? 'danger' : 'success'
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.status === 1 ? '注销中' : scope.row.status === 2 ? '已注销' : '正常'), 1)]),
          _: 2
        }, 1032, ["type"])]),
        action: _withCtx(({
          scope
        }) => [_unref(tabType) !== 'internal' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [scope.row.status == -1 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          link: "",
          disabled: ""
        }, {
          default: _withCtx(() => [_createTextVNode("已解绑")]),
          _: 1
        })) : _createCommentVNode("", true), scope.row.uid && scope.row.userType != 6 && scope.row.status != -1 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          link: "",
          type: "primary",
          onClick: $event => handleGlobalClick('unlock', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("解绑")]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleGlobalClick('reset', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("重置密码")]),
          _: 2
        }, 1032, ["onClick"])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleInternalClick('reset', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("重置密码")]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleInternalClick('realName', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("重置实名")]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleInternalClick('msg', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("重置短信次数")]),
          _: 2
        }, 1032, ["onClick"])], 64))]),
        _: 1
      }, 8, ["data", "loading", "options"])]), _createVNode(ResetPassword, {
        ref_key: "resetPasswordRef",
        ref: resetPasswordRef
      }, null, 512)], 64);
    };
  }
});